module.exports = __webpack_public_path__ + "img/Trash-Bin.4ad28f2e.svg";